import { Component, inject, signal, WritableSignal } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { UiButtonComponent } from '@app/shared/ui/button/ui-button.component';
import { UiDialogComponent } from '@app/shared/ui/dialog/ui-dialog.component';
import { TranslatePipe } from '@ngx-translate/core';

export interface ExportTasksDialogResult {
  includeSubtasks: boolean;
}

@Component({
  selector: 'proffeo-export-tasks-dialog',
  templateUrl: './export-tasks-dialog.component.html',
  imports: [UiButtonComponent, MatCheckboxModule, MatDialogModule, UiDialogComponent, TranslatePipe]
})
export class ExportTasksDialogComponent {
  private readonly dialogRef = inject<MatDialogRef<ExportTasksDialogComponent, ExportTasksDialogResult>>(MatDialogRef);

  protected readonly includeSubtasks: WritableSignal<boolean> = signal(false);

  protected setIncludeSubtasks(checked: boolean): void {
    this.includeSubtasks.set(checked);
  }

  protected cancel(): void {
    this.dialogRef.close();
  }

  protected confirmExport(): void {
    this.dialogRef.close({ includeSubtasks: this.includeSubtasks() });
  }
}
